/**
 * @ngdoc service
 * @name ims.shared.data.service:ZoneType
 * @description
 * The ims ZoneType object.
 * Object structure:
 * {id: 1,
 *  resource:{}}
 *
 * @param {ngResource} ZoneTypeResource A ZoneType ngResource object.
 */

import { ImsObject } from '../ims_object';
import { ZoneTypeResource } from '../../resources';
import { Cesium } from '../../../cesium';
import { createCesiumColorForStrOrArrayColor } from 'app/shared/utilities/ims_color';

export const IMS_TYPE__ZONE_TYPE = 'zone_type';

interface ZoneTypeColor {
    name: string;
    cesium: string;
}

export class ZoneType extends ImsObject {
    show: boolean;
    _cesiumColor: Cesium.Color;

    constructor(resource = new ZoneTypeResource()) {
        super(IMS_TYPE__ZONE_TYPE, resource);
        this.show = true;
        this._cesiumColor = createCesiumColorForStrOrArrayColor(this.cesiumColorString);
    }

    get name(): string {
        return this.resource.name;
    }

    get color(): ZoneTypeColor {
        return (
            this.resource.color || {
                name: 'white',
                cesium: 'WHITE',
            }
        );
    }

    get cesiumColorString(): string {
        return this.resource.color ? this.resource.color.cesium : 'WHITE';
    }

    get cesiumColor(): Cesium.Color {
        return this._cesiumColor;
    }

    get description(): string {
        return this.resource.description;
    }

    get staticShape(): boolean {
        return this.resource.static_shape;
    }

    get editableHistory(): boolean {
        return this.resource.editable_history;
    }

    get selectable(): boolean {
        return this.resource.selectable;
    }
}
